import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { VoyageLogPage } from './voyage-log';
import { VoyageLogComponent } from '../voyage-log-component/voyage-log-component';
import { GridModule, RowFilterModule } from '@progress/kendo-angular-grid';
import { DirectivesModule } from '../../../directives/directives.module';
import { VoyageLogAdjustmentModalComponent } from '../voyage-log-adjustment-modal/voyage-log-adjustment-modal';
import { SharedModule } from '../../shared/shared.module';
import { TextMaskModule } from 'angular2-text-mask';
import { IonicSelectableModule } from 'ionic-selectable';
import { PipesModule } from '../../../pipes/pipes.module';
import { FoundationModule } from '../../../_foundation/foundation.module';

@NgModule({
  declarations: [
    VoyageLogPage,
    VoyageLogComponent,
    VoyageLogAdjustmentModalComponent
  ],
    imports: [
        IonicPageModule.forChild(VoyageLogPage),
        GridModule,
        RowFilterModule,
        DirectivesModule,
        SharedModule,
        TextMaskModule,
        IonicSelectableModule,
        PipesModule,
        FoundationModule,
    ],
  entryComponents: [
    VoyageLogAdjustmentModalComponent
  ]
})
export class VoyageLogPageModule {
}



// WEBPACK FOOTER //
// ./src/pages/voyage-log/voyage-log/voyage-log.module.ts